<template>
  <div class="mobile-notifications-container">
    <mbHeader :title="$t('notifications_manage')" :left="true" :lang="true"></mbHeader>
    <notifications></notifications>
  </div>
</template>

<script>
import notifications from "../Profile/notifications";
import mbHeader from "../../components/mobile/mbHeader";

export default {
  name: "mobileNotifications",
  components: {notifications, mbHeader},
}
</script>

<style lang="less" scoped>
.mobile-notifications-container {
  min-height: 100vh;
  padding: 50px 0;
  background-color: rgba(0, 0, 0, 0.02);
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileNotifications.vue